import { ReactNode } from 'react';

import { Permission } from '__generated__/graphql';

import { useSession } from '../Auth/SessionProvider';
import useProject from '../useProject';

interface ProtectedSectionProps {
  permissions: Permission[];
  children?: ReactNode;
  fallback?: ReactNode;
}

const ProtectedSection = ({ permissions, children, fallback }: ProtectedSectionProps) => {
  const project = useProject();
  const { user, hasPermission } = useSession();

  if (!user || !hasPermission(project.id, permissions)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default ProtectedSection;
